import React, { FC } from 'react';
import classNames from 'classnames';
import { isPresent } from 'Shared/utils';
import { EntityIcon, EntityIconProps } from 'QuoteApp/components/EntityIcon';
import styles from './styles.module.css';

type AccordionHeaderProps = {
  dataComplete?: boolean;
  dataInvalid?: boolean;
  entity?: EntityIconProps['variant'];
  header: string;
};

export const AccordionHeader: FC<AccordionHeaderProps> = ({
  dataComplete,
  dataInvalid,
  entity,
  header,
}) => {
  return (
    <div className={styles.wrapper}>
      {entity && <EntityIcon variant={entity} className={styles.icon} />}
      <div className={styles.entityName}>
        <div className={styles.header}>
          <h5 className="fs-mask">{header}</h5>
        </div>
        {isPresent(dataComplete) && (
          <div
            className={classNames(styles.subHeader, {
              [styles.complete]: dataComplete,
            })}
          >
            Data {dataComplete ? 'Complete' : 'Incomplete'}
          </div>
        )}
        {!isPresent(dataComplete) && dataInvalid && (
          <div className={classNames(styles.subHeader)}>Data Invalid</div>
        )}
      </div>
    </div>
  );
};
